import React from 'react';

import { Redirect, Route } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, auth, ...rest }) => {
    const { search, hash, pathname } = window.location; // IMPORTANT!! do not use useLocation since it is not consistent and sometimes return wrong pathname
    const redirect = pathname !== '/' ? `${pathname}${search}${hash}` : undefined;

    const to = redirect ? `?redirect=${redirect}` : '';
    return (
        <Route
            {...rest}
            render={(props) => (auth === true ? <Component {...props} /> : <Redirect to={`/login${to}`} />)}
        />
    );
};

export default ProtectedRoute;
